<template>
    <div>
        <choice-wrap v-if="energySourceIs(['D','E'])">
            <template v-slot:title>
                <img src="../../assets/images/setup/meter.svg" alt="" class="mr-3">
                <h3>Do you know how much Electricity you use?</h3>
            </template>
            <choice v-model="selected.averageElectricityUsageUnit" :errors.sync="errors.averageElectricityUsageUnit" :data="data.usageUnits" show-button-title
                    show-button-description></choice>
        </choice-wrap>

        <collapse-transition>
            <choice-wrap v-if="selected.averageElectricityUsageUnit === 'gbp' ">
                <div class="form-usage d-flex flex-column flex-sm-row justify-content-around align-items-stretch align-items-sm-center pb-4">
                    <label class="h4 font-weight-normal mr-3 mb-3 mb-sm-0 flex-shrink-0">I pay</label>
                    <div class="flex-fill">
                        <div class="input-group  mb-3 mb-sm-0 ">
                            <div class="input-group-prepend">
                                <div class="input-group-text">&pound;</div>
                            </div>
                            <input v-model="selected.averageElectricityUsageStandardAmount"
                                   :class="{'is-invalid' : errors.averageElectricityUsageStandardAmount.length }"
                                   type="number"
                                   class="form-control form-control-lg ">
                            <div class="invalid-tooltip"
                                 v-for="(error, key) in errors.averageElectricityUsageStandardAmount" :key="key">
                                {{ error }}
                            </div>
                        </div>
                    </div>
                    <div class="ml-0 ml-sm-3 flex-shrink-0">
                        <select class="custom-select custom-select-lg  " v-model="selected.averageElectricityUsagePeriod">
                            <option v-for="(period, key) in data.usagePeriods" :key="key" :value="period.id">
                                {{ period.title }}
                            </option>
                        </select>
                    </div>
                </div>
            </choice-wrap>
        </collapse-transition>
        <collapse-transition>
            <choice-wrap v-if="selected.averageElectricityUsageUnit === 'kwh' && !isUsingE7 ">
            <div class="form-usage d-flex flex-column flex-sm-row justify-content-around align-items-stretch align-items-sm-center pb-4">
                <label class="h4 font-weight-normal mr-3 mb-3 mb-sm-0 flex-shrink-0" >I use</label>
                <div class="flex-fill">
                    <div class="input-group  mb-3 mb-sm-0 ">
                        
                        <input v-model="selected.averageElectricityUsageStandardAmount"
                               :class="{'is-invalid' : errors.averageElectricityUsageStandardAmount.length }"
                               type="number"
                               class="form-control form-control-lg">
                        <div class="invalid-tooltip" v-for="(error, key) in errors.averageElectricityUsageStandardAmount" :key="key">
                            {{error}}
                        </div>
                        <div class="input-group-append">
                            <div class="input-group-text">kWh</div>
                        </div>
                    </div>
                </div>
                <div class="ml-0 ml-sm-3 flex-shrink-0">
                    <select class="custom-select custom-select-lg" v-model="selected.averageElectricityUsagePeriod" >
                        <option v-for="(period, key) in data.usagePeriods" :key="key" :value="period.id">
                            {{ period.title }}
                        </option>
                    </select>
                </div>
            </div>
        </choice-wrap>
        </collapse-transition>
        <collapse-transition>
            <choice-wrap v-if="selected.averageElectricityUsageUnit === 'kwh' && isUsingE7">
                <label class="h4 font-weight-normal mr-3 mb-3  ">In daytime I use</label>
                <div class="form-usage d-flex flex-column flex-sm-row justify-content-around align-items-stretch align-items-sm-center pb-4">
                    <div class="flex-fill">
                        <div class="input-group  mb-3 mb-sm-0 ">
                            <input v-model="selected.averageElectricityUsageDailyAmount"
                                   :class="{'is-invalid' : errors.averageElectricityUsageDailyAmount.length }" type="number"
                                   class="form-control form-control-lg">
                            <div class="invalid-tooltip" v-for="(error, key) in errors.averageElectricityUsageDailyAmount"
                                 :key="key">
                                {{ error }}
                            </div>
                            <div class="input-group-append">
                                <div class="input-group-text">kWh</div>
                            </div>
                        </div>
                        
                    </div>
                    <div class="ml-0 ml-sm-3 flex-shrink-0">
                        <select class="custom-select custom-select-lg" v-model="selected.averageElectricityUsagePeriod">
                            <option v-for="(period, key) in data.usagePeriods" :key="key" :value="period.id">
                                {{ period.title }}
                            </option>
                        </select>
                    </div>
                </div>
                <label class="h4 font-weight-normal mr-3 mb-3  ">In nighttime I use</label>
                <div class="form-usage  form-usage d-flex flex-column flex-sm-row justify-content-around align-items-stretch align-items-sm-center pb-4">
                    
                    <div class="flex-fill">
                        <div class="input-group  mb-3 mb-sm-0 ">
                            <input v-model="selected.averageElectricityUsageNightlyAmount"
                                   :class="{'is-invalid' : errors.averageElectricityUsageNightlyAmount.length }" type="number"
                                   class="form-control form-control-lg">
                            <div class="invalid-tooltip" v-for="(error, key) in errors.averageElectricityUsageNightlyAmount"
                                 :key="key">
                                {{ error }}
                            </div>
                            <div class="input-group-append">
                                <div class="input-group-text">kWh</div>
                            </div>
                        </div>
                        
                    </div>
                    <div class="ml-0 ml-sm-3 flex-shrink-0">
                        <select class="custom-select custom-select-lg" v-model="selected.averageElectricityUsagePeriod">
                            <option v-for="(period, key) in data.usagePeriods" :key="key" :value="period.id">
                                {{ period.title }}
                            </option>
                        </select>
                    </div>
                </div>
            </choice-wrap>
        </collapse-transition>
        <choice-wrap  v-if="energySourceIs(['D','G'])">
            <template v-slot:title>
                <img src="../../assets/images/setup/meter.svg" alt="" class="mr-3">
                <h3>Do you know how much Gas you use?</h3>
            </template>
            <choice v-model="selected.averageGasUsageUnit" :errors.sync="errors.averageGasUsageUnit" :data="data.usageUnits" show-button-title
                    show-button-description></choice>
        </choice-wrap>

        <collapse-transition>
        <choice-wrap v-if="!! selected.averageGasUsageUnit && selected.averageGasUsageUnit !== 'unknown'">
            <div class="form-usage d-flex flex-column flex-sm-row justify-content-around align-items-stretch align-items-sm-center pb-4">
                <label class="h4 font-weight-normal mr-3 mb-3 mb-sm-0 flex-shrink-0" v-if="selected.averageGasUsageUnit === 'kwh'">I use</label>
                <label class="h4 font-weight-normal mr-3 mb-3 mb-sm-0 flex-shrink-0" v-if="selected.averageGasUsageUnit === 'gbp'">I pay</label>
                <div class="flex-fill">
                    <div class="input-group  mb-3 mb-sm-0 ">
                        <div class="input-group-prepend" v-if="selected.averageGasUsageUnit === 'gbp'">
                            <div class="input-group-text">&pound;</div>
                        </div>
                        <input v-model="selected.averageGasUsageAmount"
                               :class="{'is-invalid' : errors.averageGasUsageAmount.length }" type="number"
                               class="form-control form-control-lg">
                        <div class="invalid-tooltip" v-for="(error, key) in errors.averageGasUsageAmount" :key="key">
                            {{ error }}
                        </div>
                        <div class="input-group-append" v-if="selected.averageGasUsageUnit === 'kwh'">
                            <div class="input-group-text">kWh</div>
                        </div>
                    </div>
                </div>
                <div class="ml-0 ml-sm-3 flex-shrink-0">
                    <select class="custom-select custom-select-lg" v-model="selected.averageGasUsagePeriod">
                        <option v-for="(period, key) in data.usagePeriods" :key="key" :value="period.id">
                            {{ period.title }}
                        </option>
                    </select>
                </div>

            </div>
        </choice-wrap>
        </collapse-transition>
        <choice-wrap>
            <template v-slot:title>
                <img src="../../assets/images/setup/creditcard.svg" alt="" class="mr-3">
                <h3>How you would pay for your energy in the future?</h3>
            </template>
            <choice v-model="selected.preferPaymentScheme" :errors.sync="errors.preferPaymentScheme" :data="preferPaymentSchemes" show-button-title
                    show-button-description></choice>
        </choice-wrap>
        <choice-wrap v-if="energySourceIs(['D','E'])">
            <template v-slot:title>
                <img src="../../assets/images/setup/leaf.svg" alt="" class="mr-3">
                <h3>Would you like to use Electricity ONLY from Renewable Sources?</h3>
            </template>
            <choice v-model="selected.preferRenewableSources" :errors.sync="errors.preferRenewableSources" :data="data.preferRenewableSources" show-button-title></choice>
        </choice-wrap>
    </div>
</template>

<script>
import ChoiceWrap from "../../components/setup/ChoiceWrap";
import Choice from "../../components/setup/Choice";
import SetupChoiceUpdate from "../../mixins/SetupChoiceUpdate";
import SetupValidationHelper from "../../mixins/SetupValidationHelper";
import {CollapseTransition} from "vue2-transitions"
import {mapGetters} from 'vuex'
export default {
        name: "Usage",
        components: {Choice, ChoiceWrap,CollapseTransition},
        mixins: [SetupChoiceUpdate, SetupValidationHelper],
        data: function () {
            return {
                nextRouteName: 'SetupDeal',
                defaults: {
                    averageElectricityUsagePeriod: 'annually',
                    averageGasUsagePeriod: 'annually',
                    preferPaymentScheme: 'MDD',
                    preferRenewableSources: "0",
                },
                selected: {
                    averageElectricityUsageUnit: null,
                    averageElectricityUsageStandardAmount: null,
                    averageElectricityUsageDailyAmount: null,
                    averageElectricityUsageNightlyAmount: null,
                    averageElectricityUsagePeriod: null,
                    averageGasUsageUnit: null,
                    averageGasUsageAmount: null,
                    averageGasUsagePeriod: null,
                    preferPaymentScheme: null,
                    preferRenewableSources: null,
                },
                errors: {
                    averageElectricityUsageUnit: [],
                    averageElectricityUsageStandardAmount: [],
                    averageElectricityUsageDailyAmount: [],
                    averageElectricityUsageNightlyAmount: [],
                    averageElectricityUsagePeriod: [],
                    averageGasUsageUnit: [],
                    averageGasUsageAmount: [],
                    averageGasUsagePeriod: [],
                    preferPaymentScheme: [],
                    preferRenewableSources: [],
                },
            }
        },
        methods: {
            energySourceIs: function (sourceType) {
                if (!Array.isArray(sourceType)) {
                    sourceType = [sourceType]
                }
                return sourceType.indexOf(this.currentEnergySource) >= 0
            },
            validate: function () {
                this.resetErrors();
                if((this.energySourceIs(['D','E']))
                    && !this.selected.averageElectricityUsageUnit){
                    this.errors.averageElectricityUsageUnit.push("Please tell us if you know how much electricity do you use?")
                }
    
                if (this.energySourceIs(['D', 'E']) && this.isUsingE7 && this.selected.averageElectricityUsageUnit === 'kwh') {
                    if(!this.selected.averageElectricityUsageDailyAmount) {
                        this.errors.averageElectricityUsageDailyAmount.push("Please enter your daytime energy usage!")
                    }
                    if(!this.selected.averageElectricityUsageNightlyAmount) {
                        this.errors.averageElectricityUsageNightlyAmount.push("Please enter your nighttime energy usage!")
                    }
                } else {
                    if (this.energySourceIs(['D', 'E'])
                        && !!this.selected.averageElectricityUsageUnit
                        && this.selected.averageElectricityUsageUnit !== 'unknown'
                        && !this.selected.averageElectricityUsageStandardAmount) {
                        this.errors.averageElectricityUsageStandardAmount.push("Please enter your energy usage!")
                    } else if (this.energySourceIs(['D', 'E']) &&
                        !!this.selected.averageElectricityUsageUnit
                        && this.selected.averageElectricityUsageUnit !== 'unknown'
                        && isNaN(parseInt(this.selected.averageElectricityUsageStandardAmount))) {
                        this.errors.averageElectricityUsageStandardAmount.push("Please enter your energy usage!")
                    }
                }

                if(this.energySourceIs(['D','G']) && !this.selected.averageGasUsageUnit){
                    this.errors.averageGasUsageUnit.push("Please tell us if you know how much gas do you use?")
                }

                if(this.energySourceIs(['D','G']) && !!this.selected.averageGasUsageUnit
                    && this.selected.averageGasUsageUnit !== 'unknown'
                    && !this.selected.averageGasUsageAmount){
                    this.errors.averageGasUsageAmount.push("Please enter your gas usage!")
                } else if(this.energySourceIs(['D','G']) && !!this.selected.averageGasUsageUnit
                    && this.selected.averageGasUsageUnit !== 'unknown'
                    && isNaN(parseInt(this.selected.averageGasUsageAmount))){
                    this.errors.averageGasUsageAmount.push("Please enter your energy usage!")
                }
                if(this.energySourceIs(['D','E']) && !this.selected.preferRenewableSources){
                    this.errors.preferRenewableSources.push("Please tell us if you would prefer energy from renewable sources?")
                }
            }
        },
        computed: {
            data: function () {
                return this.$store.getters["setup/stepThreeData"]
            },
            ...mapGetters('setup', [
                'currentEnergySource',
                'currentElectricityPaymentScheme',
                'currentGasPaymentScheme',
                'isUsingE7'
            ]),
            preferPaymentSchemes: function (){
               
                if(this.currentElectricityPaymentScheme === 'PRE' || this.currentGasPaymentScheme === 'PRE'){
                    return this.data.preferPaymentSchemes.filter(v => v.id === 'PRE')
                }
                return this.data.preferPaymentSchemes.filter(v => v.id === 'MDD')
            }
        },
        watch: {
            'selected.averageElectricityUsageStandardAmount': function () {
                this.errors.averageElectricityUsageStandardAmount = []
            },
            'selected.averageGasUsageAmount': function () {
                this.errors.averageGasUsageAmount = []
            },
            'selected.averageElectricityUsagePeriod': function () {
                this.errors.averageElectricityUsagePeriod = []
            },
            'selected.averageGasUsagePeriod': function () {
                this.errors.averageGasUsagePeriod = []
            },
            'selected.averageElectricityUsageUnit': function (newUnit, oldUnit) {
                if(newUnit === null || oldUnit == null || newUnit === oldUnit) return;
                let choice = this.$store.getters["setup/choice"];
                
                choice.averageElectricityUsageStandardAmount = null;
                choice.averageElectricityUsageDailyAmount = null;
                choice.averageElectricityUsageNightlyAmount = null;
                choice.averageElectricityUsagePeriod = 'annually';

                this.$store.commit('setup/setChoice', choice);

                this.selected.averageElectricityUsageStandardAmount = null;
                this.selected.averageElectricityUsageDailyAmount = null;
                this.selected.averageElectricityUsageNightlyAmount = null;
                this.selected.averageElectricityUsagePeriod = 'annually';
            },
            'selected.averageGasUsageUnit': function (newUnit, oldUnit) {
                if(newUnit === null || oldUnit == null || newUnit === oldUnit) return;
                let choice = this.$store.getters["setup/choice"];

                choice.averageGasUsageAmount = null;
                choice.averageGasUsagePeriod = 'annually';

                this.$store.commit('setup/setChoice', choice);

                this.selected.averageGasUsageAmount = null;
                this.selected.averageGasUsagePeriod = 'annually';
            }
        }
    }
</script>
<style scoped lang="scss">
    @import "../../sass/base";

    .form-inline, .form-usage {

        .input-group {
            border: 1px solid $gray-600 !important;
            border-radius: $border-radius;

            &:focus-within {
                box-shadow: $btn-focus-box-shadow;
            }

            input {
                border: none;

                &:focus {
                    box-shadow: none;
                }
            }

            .input-group-append, .input-group-prepend {
                > .input-group-text {
                    background: #fff;
                    border: none;
                    color: $gray-500;
                }
            }
        }

        .custom-select {
            border: 1px solid $gray-600 !important;
        }
    }
</style>
